import { each } from "fxjs/es";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
export const initEditor = (self) => {
  const canvas_el = self._getCanvasElThrowable();
  const layers_el = self._getLayersElThrowable();
  const target_image_layer_el = self._getTargetImageLayerElThrowable();
  const target_image_dummy_g_el = self._getTargetImageDummyGElThrowable();
  const view_port = new ViewPortNS.ModelNS.ViewPort({
    width: 0,
    height: 0,
  });
  const view_port_controller = new ViewPortNS.ControllerNS.ViewPortController({
    view_port,
  });
  each(
    (el) =>
      new ViewPortNS.ViewNS.ViewPortElView({
        view_port_el: el,
        view_port_controller,
      })
  )([canvas_el, layers_el]);
  self._view_port = view_port;
  const view_box = new ViewBoxNS.ModelNS.ViewBox({
    svg_el: self._svg_el,
    min_s: self._min_zoom_scale,
    max_s: self._max_zoom_scale,
  });
  const view_box_controller = new ViewBoxNS.ControllerNS.ViewBoxController({
    view_box,
  });
  new ViewBoxNS.ViewNS.ViewBoxElView({
    view_box_el: layers_el,
    view_box_controller,
  });
  self._view_box = view_box;
  const stroke = new StrokeNS.ModelNS.Stroke({
    svg_el: self._svg_el,
    getCTM: () => {
      const target_image_dummy_g_ctm = target_image_dummy_g_el.getCTM();
      if (target_image_dummy_g_ctm == null) {
        throw new Error(`target_image_dummy_g_el 의 CTM 을 구할 수 없습니다.`);
      }
      const target_image_layer_ctm = target_image_layer_el.getCTM();
      if (target_image_layer_ctm == null) {
        throw new Error(`target_image_layer_el 의 CTM 을 구할 수 없습니다.`);
      }
      return target_image_layer_ctm.multiply(target_image_dummy_g_ctm);
    },
  });
  const stroke_sync = new StrokeNS.ModelNS.StrokeSync({
    SVGGraphicsElement: self._window.SVGGraphicsElement,
    el: target_image_layer_el,
    stroke,
  });
  view_port_controller.subscribe(() => {
    if (self._target_image_el == null) {
      return;
    }
    stroke_sync.sync();
  });
  view_box_controller.subscribe(() => {
    if (self._target_image_el == null) {
      return;
    }
    stroke_sync.sync();
  });
  self._stroke_sync = stroke_sync;
  self._touchStartHandler = (event) => self._handleTouchStart(event);
  self._touchMoveHandler = (event) => self._handleTouchMove(event);
  self._touchEndOrCancelHandler = (event) =>
    self._handleTouchEndOrCancel(event);
  canvas_el.addEventListener("touchstart", self._touchStartHandler, {
    passive: false,
  });
  self._window.addEventListener("touchmove", self._touchMoveHandler, {
    passive: false,
  });
  self._window.addEventListener("touchend", self._touchEndOrCancelHandler, {
    passive: false,
  });
  self._window.addEventListener("touchcancel", self._touchEndOrCancelHandler, {
    passive: false,
  });
};
